export default "__VITE_ASSET__B2_hmbNN__"